// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { reSubmitExpiredQuote, ReSubmittedQuote, ReSubmittedQuoteMessage } from "@ces/App/Services/QuoteService";

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

type HandlerType = ApiHandler<
    ReSubmittedQuote & HasOnSuccess<ReSubmittedQuoteMessage> & HasOnError<string>,
    ServiceResult<ReSubmittedQuoteMessage>
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        quoteNumber: props.parameter.quoteNumber,
    };
};

export const sendDataToApi: HandlerType = async props => {
    const { parameter, apiParameter } = props;
    const result = await reSubmitExpiredQuote(apiParameter);
    if (result.successful) {
        props.apiResult = result;
    } else {
        parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult?.successful) {
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const chain = [PopulateApiParameter, sendDataToApi, ExecuteOnSuccessCallback];

const reSubmitQuote = createHandlerChainRunner(chain, "reSubmitQuote");
export default reSubmitQuote;
